import React, { useState } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./Input.css";
import withHelpText from "./withHelpText";

import Tooltip from "../../uiElements/tooltip/Tooltip";

const TextInput = ({
  value,
  type,
  placeholder,
  onChange,
  className,
  label,
  error,
  required,
  disabled,
  maxLength,
  autoFocus = false,
  onKey,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const localStringToNumber = s => {
    return Number(String(s).replace(/[^0-9.-]+/g, ""));
  };

  const onFocus = e => {
    var value = e.target.value;
    e.target.value = value ? localStringToNumber(value) : "";
  };

  const onBlur = e => {
    var value = e.target.value;
    var options = {
      maximumFractionDigits: 2,
      currency: "USD",
      style: "currency",
      currencyDisplay: "symbol",
    };
    onChange(
      value || value === 0
        ? localStringToNumber(value).toLocaleString("en-US", options)
        : ""
    );
  };

  return (
    <div className="form-group floating mt-n4">
      {required && (
        <span className="text-danger" style={{ marginLeft: 5 }}>
          *
        </span>
      )}
      <input
        type={type === "password" ? (showPassword ? "text" : type) : type}
        autoComplete={type === "password" && "one-time-code"}
        className={classnames("form-control floating", className)}
        placeholder={placeholder}
        required
        title=""
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        onFocus={e => type === "currency" && onFocus(e)}
        onBlur={e => type === "currency" && onBlur(e)}
        min={type === "number" && 0}
        maxLength={maxLength}
        step={0.1}
        onInput={e =>
          type === "number" &&
          (e.target.value = e.target.value.slice(0, maxLength))
        }
        autoFocus={autoFocus}
        onKeyPress={onKey}
      />
      {label && (
        <label className="text-left input-label">{!disabled && label}</label>
      )}

      {type === "password" && (
        <button
          className="showBtn"
          onClick={() => setShowPassword(prevState => !prevState)}
        >
          {showPassword ? "Hide" : "Show"}
        </button>
      )}
      {error && (
        <Tooltip id={error} className="errorBtn">
          {error}
        </Tooltip>
      )}
    </div>
  );
};

//TODO - add prop-types to all components
TextInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
};

TextInput.defaultProps = {
  value: "",
  onChange: undefined,
  type: "text",
  placeholder: "",
  className: "",
  required: false,
  disabled: false,
  maxLength: undefined,
};
export default TextInput;

export const TextInputWithHelpText = withHelpText(TextInput);
